if (!customElements.get('ak-cart-feedback')) {
  customElements.define('ak-cart-feedback', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.addEventListener('click', event => {
        if (event.target.closest('[data-ak-cart-dismiss]')) this.close();
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') { event.preventDefault(); this.close(); }
      }, { signal });
      this.addEventListener('pointerenter', () => clearTimeout(this.timer), { signal });
      this.addEventListener('pointerleave', () => this.scheduleClose(), { signal });
      this.addEventListener('focusin', () => clearTimeout(this.timer), { signal });
      this.addEventListener('focusout', () => this.scheduleClose(), { signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
      clearTimeout(this.timer);
    }

    getSectionsToRender() { return [{ id: 'ankyra-cart-count' }]; }

    setActiveElement(element) { this.activeElement = element; }

    renderContents(cartData) {
      const item = cartData.items?.[0] || cartData;
      const title = item.product_title || item.title || '';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
      this.querySelector('[data-ak-cart-product]').textContent = [title, variant].filter(Boolean).join(' · ');
      this.hidden = false;
      this.scheduleClose();

      // Section-rendering failure does not undo a successful cart addition.
      // Reconcile the badge with a read-only cart request; never re-submit the add.
      const section = cartData.sections?.['ankyra-cart-count'];
      const countElement = section && new DOMParser().parseFromString(section, 'text/html').querySelector('[data-ak-cart-count]');
      if (countElement) {
        this.countRevision = (this.countRevision || 0) + 1;
        this.updateCount(Number(countElement.dataset.akCartCount), countElement.dataset.akCartLabel);
      } else {
        this.refreshCount();
      }
    }

    updateCount(count, label) {
      if (!Number.isSafeInteger(count) || count < 0) return;
      document.querySelectorAll('.ak-cart #cart-icon-bubble').forEach(bubble => {
        bubble.textContent = String(count);
        bubble.closest('.ak-cart').setAttribute('aria-label', label || `${this.dataset.cartLabel}: ${count}`);
      });
    }

    async refreshCount() {
      const revision = this.countRevision = (this.countRevision || 0) + 1;
      try {
        const response = await fetch(`${window.Shopify.routes.root}cart.js`, { headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        if (revision === this.countRevision && this.isConnected) this.updateCount(cart.item_count);
      } catch (_) {
        // The item is already added. Keep the confirmation and the explicit cart link.
      }
    }

    scheduleClose() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (!this.matches(':hover') && !this.contains(document.activeElement)) this.close();
      }, 8000);
    }

    close() {
      clearTimeout(this.timer);
      const restoreFocus = this.contains(document.activeElement);
      this.hidden = true;
      if (restoreFocus && this.activeElement?.isConnected) this.activeElement.focus({ preventScroll: true });
    }
  });
}
